import {Component, OnInit} from '@angular/core';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzTableModule} from 'ng-zorro-antd/table';
import {CommonModule} from '@angular/common';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {FormsModule} from '@angular/forms';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {NzInputModule} from 'ng-zorro-antd/input';
import {KBService} from '../services/kb.service';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {MarkdownComponent} from 'ngx-markdown';
import {NzUploadModule} from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-admin-feedback',
  standalone: true,
  imports: [
    CommonModule,
    NzCardModule,
    NzButtonModule,
    NzTableModule,
    NzModalModule,
    FormsModule,
    NzFormModule,
    NzTagModule,
    NzInputModule,
    NzTabsModule,
    MarkdownComponent,
    NzUploadModule
  ],
  templateUrl: './admin-feedback.component.html',
  styleUrl: './admin-feedback.component.less'
})
export class AdminFeedbackComponent implements OnInit{
  feedbackList: any[] = [];
  filtered: any[] = [];
  loading = false;
  searchText = '';
  sortMap: { [key: string]: 'ascend' | 'descend' | null } = {
    question: null,
    feedback: null,
    createdAt: null
  };

  constructor(private kbService: KBService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.kbService.getFeedback().subscribe({
      next: res => {
        this.feedbackList = res;
        this.filtered = [...res];
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  applySearch(): void {
    const term = this.searchText.toLowerCase();
    this.filtered = this.feedbackList.filter(f =>
      f.question.toLowerCase().includes(term)
    );
  }

  sort(field: string, order: string): void {
    this.filtered = [...this.filtered].sort((a, b) => {
      const valA = a[field];
      const valB = b[field];
      const dir = order === 'ascend' ? 1 : -1;
      return (valA > valB ? 1 : valA < valB ? -1 : 0) * dir;
    });
  }
  changeSort(field: string, order: string | null): void {
    // Reset all sort states
    Object.keys(this.sortMap).forEach(key => {
      this.sortMap[key] = null;
    });

    // Handle invalid sort (empty or unsupported)
    if (order !== 'ascend' && order !== 'descend') {
      this.filtered = [...this.feedbackList];
      return;
    }

    // Save valid sort order
    this.sortMap[field] = order;

    const multiplier = order === 'ascend' ? 1 : -1;
    this.filtered.sort((a, b) => {
      const valA = a[field];
      const valB = b[field];
      return (valA > valB ? 1 : valA < valB ? -1 : 0) * multiplier;
    });
  }
}
